import SOURCE_TYPE from '../../SourceCreate.constants';

/**
 * Determines the appropriate Lima device for customer cloud source page.
 *
 * Business Rules:
 * - Restricted orgs use lima-aws-0r
 * - Azure sources use lima-azure-01
 * - All other sources use lima-aws-01
 *
 * @param sourceTypeId - The ID of the source type being configured
 * @param isRestricted - Whether the organization is restricted
 * @param devices - Array of available Lima devices
 * @returns The device_uid of the appropriate Lima device, or empty string if not found
 */
export const getLimaDeviceForCustomerSource = (
  sourceTypeId: number,
  isRestricted: boolean,
  devices: Array<{ device_uid: string; host_name: string }>
): string => {
  if (isRestricted) {
    return (
      devices?.find((device) => device.host_name.includes('lima-aws-0r'))
        ?.device_uid || ''
    );
  }

  const isAzureSource =
    sourceTypeId === SOURCE_TYPE.AZURE_EVENT_HUB ||
    sourceTypeId === SOURCE_TYPE.AZURE_VIRTUAL_NETWORK_FLOW_LOGS;

  const hostNamePattern = isAzureSource ? 'lima-azure-01' : 'lima-aws-01';

  return (
    devices?.find((d) => d.host_name.includes(hostNamePattern))?.device_uid ||
    ''
  );
};
